<template>
  <div id="news-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-news" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="container">

      <div class="section-title">
        <h2>新闻动态</h2>
        <p>NEWS</p>
      </div>

      <el-row :gutter="15">

        <el-col :span="18">
          <ul v-if="this.reDataList.length > 0">

            <li v-for="(bean, index) in reDataList" :key="index" class="content-list-items">
				<a :href="'/news/detail/' + bean.id" target = "_blank">
					<el-row>
						<el-col :span="6" class="left">
						  <a :href="'/news/detail/' + bean.id" target="_blank">
							<img v-if="typeof bean.image === 'undefined' || bean.image == null || bean.image === ''"
							  src="~@/static/img/news/default.jpg" class="rounded-sm cm-media-img"
							  style="width: 250px;height: 150px;" alt="标题图片">
							<img v-else :src="bean.image" class="rounded-sm cm-media-img" style="width: 250px;height: 150px;"
							  alt="标题图片">
						  </a>
						</el-col>
						<el-col :span="18" class="right">
						  <p class="item-title">
							<a :href="'/news/detail/' + bean.id" target="_blank">
							  {{ bean.title }}
							</a>
						  </p>
						  <p class="item-summary" v-html="bean.summary">
						  </p>
						  <p class="item-date">
							<i class="el-icon-time"></i> {{ formatDate(bean.createTime) }}
						  </p>
						</el-col>
					</el-row>
			    </a>
            </li>
          </ul>

          <!-- empty -->
          <div v-else class="home_empty_list">
            <i class="font iconfont">&#xe600;</i>暂无相关数据！
          </div>
          <!--pager-->
          <div class="pager_block" style="clear: both;" v-if="this.reDataList.length > 0">
            <el-pagination @current-change="current_change" background layout="total, prev, pager, next, jumper"
              :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
          </div>
        </el-col>

        <el-col :span="6">
          <div class="right-sidebar">
            <h5 class="sidebar-title"><i class="el-icon-folder"></i> 新闻分类</h5>
            <div class="sidebar-item">
              <div @click="queryParam.channelId=111;current_page = 1;getArticlePageList()">
                  <a href="javascript:void(0)" :class="queryParam.channelId == 111 ? 'active-link' : ''">
                    全部分类
                  </a>
              </div>
              <div v-for="(v, k) in reSubChannelList" :key="k" @click="queryParam.channelId=v.id;current_page = 1;getArticlePageList(v)">
                  <a href="javascript:void(0)" :class="queryParam.channelId == v.id ? 'active-link' : ''">
                    {{ v.channelName }}
                  </a>
              </div>
            </div>

            <h5 class="sidebar-title"><i class="el-icon-document"></i> 热点新闻</h5>
            <div class="sidebar-item hots">
              <div v-for="(v, k) in reTopList" :key="k" :title="v.title">
                  <span style="width: 4px;height: 4px;border-radius: 50%;margin-bottom: 3px;vertical-align: middle;margin-right: 1px;background: #000;display: inline-block;"></span><router-link :to="'/news/detail/' + v.id">
                    {{ v.title }}
                  </router-link>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import store from '@/store'
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
  data() {
    return {
      queryParam: {
        channelId: 111,
        isShow: 1,
        page: 1,
        limit: 10
      },
      //当前栏目id
      currChannelId: 111,

      current_page: 1,
      page_size: 10,
      total_pages: 0,
      total_data: 0,

      reSubChannelList: [],
      reDataList: [],
      reTopList: [],

    };
  },
  // watch: {
  //   '$route'() {
  //     this.queryParam.channelId = this.$route.params.id;
  //     this.getArticlePageList();
  //   }
  // },
  computed: {
  },
  methods: {

    getArticlePageList(v) {
      if (v) {
        //添加标题和meta标签
        document.title =v.channelName + '-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        meta.content = v.channelName
        
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
            if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                m[i].remove()
            }
        }
      }
      this.queryParam.page = this.current_page
      this.$get(this.$api.getArticlePageList, this.queryParam).then(response => {
        if (response.code === 0) {
          this.reDataList = response.data.list;

          this.page_size = response.data.pagesize;
          this.total_pages = response.data.totalpages;
          this.total_data = response.data.totalrecords;

          this.loading = false
        } else {
          window.console.log(response.msg);
        }
      });
    },
    getSubChannelList() {
      this.$get(this.$api.getSubChannelList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reSubChannelList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    getArticleTopList() {
      this.$get(this.$api.getArticleTopList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reTopList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    // 分页改变
    current_change: function (e) {
      this.current_page = e;
      this.getArticlePageList();
    },
    // yyyy-MM-dd HH:mm:ss
    formatDate(value) { // 时间戳转换日期格式方法
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear()// 年
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        return y + '-' + MM + '-' + d
      }
    },

    //yyyy-MM-dd HH：mm：ss
    formatDateTime(value) { // 时间戳转换日期格式方法
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear() // 年
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours() // 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },

  },
  created() {
    // if (typeof this.$route.params.id == "undefined") {
    //   this.queryParam.channelId = this.currChannelId;
    // }
    if(store.state.tempid){
      this.queryParam.channelId = store.state.tempid
    }
    this.getSubChannelList();
    this.getArticlePageList();
    this.getArticleTopList();
    //添加标题和meta标签
    let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
			document.title='新闻动态-河北科瑞达仪器科技股份有限公司'
			let m = document.querySelectorAll('meta');
			const meta = document.createElement('meta')
			meta.name = 'keywords'
			for(let i=0;i<m.length;i++){
				arr.some(item => {
					if(item == m[i].content){
						m[i].remove()
					}
				})
			}
			meta.content = '新闻动态'
			
			m[0].after(meta)
			for(let i=0;i<m.length;i++){
				if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
					m[i].remove()
				}
			}
  },
  beforeDestroy(){
    store.commit('set_temp_id', '')
  },
  mounted() {
    document.title='新闻动态-河北科瑞达仪器科技股份有限公司'
  }
};
</script>
<style scoped>
/deep/ .more{
    float: none;
}
>>> .el-pagination__jump{
    margin-left: 10px;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-news {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/news-banner.jpg");
  background-size: cover;
  position: relative;
}
#news-index{
  overflow-x: hidden;
}
.content-list-items .right{
	width: 65%;
	margin-left: 10px;
}
.content-list-items .left{
	margin-top: 5px;
	margin-left: 20px;
}
.content-list-items .left{
	width: 250px;
	height: 150px;
	overflow: hidden;
}
.content-list-items:hover .left img{
	transform: scale(1.1);
	transition: 0.8s;
}
.content-list-items{
	margin-bottom: 0;
	padding-top: 25px;
}
.content-list-items:hover .right .item-title a{
	color: #f72905
}
.content-list-items:hover {
	box-shadow: 0 0 22px rgba(0,0,0,.12);
}
.item-summary /deep/ p{
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;/*重点，不能用block等其他*/
	-webkit-line-clamp: 3;/*重点IE和火狐不支持*/
	-webkit-box-orient: vertical;/*重点*/
}
.item-summary{
	width: 578px;
	min-height: 85px;
}
.content-list-items .el-row{
	margin-bottom: 25px;
}
.hots div{
	font-size: 14px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>